/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IEditTextFieldModalController extends ng.IScope {
        modalTitle: string;
        fieldName: string;
        fieldContent: string;
        dismissable: boolean;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * CREditModalController class
     */
    export class EditTextFieldModalController {
        public static templateURL: string = "decorators/modals/edit-text-field-modal.html";
        public static ID: string = "#id-edit-text-field-modal";
        public static $name: string = "editTextFieldModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'modalTitle', 'fieldName', 'fieldContent', 'dismissable'];

        private $scope: IEditTextFieldModalController;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IEditTextFieldModalController,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    modalTitle: string,
                    fieldName: string,
                    fieldContent: string,
                    dismissable: boolean) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);
            this.$scope = $scope;
            this.$scope.modalTitle = modalTitle;
            this.$scope.fieldName = fieldName;
            this.$scope.fieldContent = fieldContent;
            this.$scope.dismissable = dismissable;
            this.close = close;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (this.$scope.fieldContent !== undefined && this.$scope.fieldContent !== "") {
                    this.close(this.$scope.fieldContent);
                }
            };
        }
    }
}
